import { render, staticRenderFns } from "./icon-prefix.vue?vue&type=template&id=316f2c90&scoped=true"
import script from "./icon-prefix.vue?vue&type=script&lang=js"
export * from "./icon-prefix.vue?vue&type=script&lang=js"
import style0 from "./icon-prefix.vue?vue&type=style&index=0&id=316f2c90&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f2c90",
  null
  
)

export default component.exports